import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_24 } from '../../Button'
import { CALENDAR_GRID_EMPTY_COUNT } from '../CalendarGrid.constants'
import { getIsCalendarGridDayFull } from '../CalendarGrid.utils'
import { CalendarGridDayLoadChip } from '../CalendarGridDayLoadChip'
import { CalendarGridDayPopoverTrigger } from '../CalendarGridDayPopoverTrigger'

import { QA_NAME_CALENDAR_GRID_DAY_MORE } from './CalendarGridDayChips.constants'
import {
  getCalendarGridDayChips,
  getCalendarGridDayLoadItems,
  getCalendarGridDayOverflowCount,
  getHasCalendarGridDayOverflow,
} from './CalendarGridDayChips.utils'
import { CalendarGridDayChipsItem } from './CalendarGridDayChipsItem'

import * as styles from './CalendarGridDayChips.module.css'

function CalendarGridDayChips({
  canMoveItems,
  chipItems,
  day,
  dayLoad,
  dayLoadLabel,
  getIsItemDragDisabled,
  items,
  moreHeight = BUTTON_HEIGHT_24,
  spanCount = CALENDAR_GRID_EMPTY_COUNT,
  onClickItem,
  onClickSecondaryLabel,
}) {
  const { t } = useTranslation()

  const laneItems = chipItems ?? items

  const overflowCount = getCalendarGridDayOverflowCount({
    dayLoad,
    items: laneItems,
    spanCount,
  })

  return (
    <>
      {getIsCalendarGridDayFull(dayLoad) ? (
        <CalendarGridDayPopoverTrigger
          isDayLoadView
          Trigger={CalendarGridDayLoadChip}
          day={day}
          dayLoad={dayLoad}
          items={getCalendarGridDayLoadItems(items)}
          triggerProps={{ children: dayLoadLabel }}
          onClickItem={onClickItem}
          onClickSecondaryLabel={onClickSecondaryLabel}
        />
      ) : null}
      {getCalendarGridDayChips({ dayLoad, items: laneItems, spanCount }).map(
        item => (
          <CalendarGridDayChipsItem
            canMoveItems={canMoveItems}
            day={day}
            dayItems={items}
            dayLoad={dayLoad}
            getIsItemDragDisabled={getIsItemDragDisabled}
            item={item}
            key={item.id}
            onClickItem={onClickItem}
            onClickSecondaryLabel={onClickSecondaryLabel}
          />
        )
      )}
      {getHasCalendarGridDayOverflow(overflowCount) ? (
        <CalendarGridDayPopoverTrigger
          Trigger={Button.Flat}
          day={day}
          dayLoad={dayLoad}
          items={items}
          triggerProps={{
            className: styles.more,
            height: moreHeight,
            qaName: QA_NAME_CALENDAR_GRID_DAY_MORE,
            text: t('Calendar.DayMoreKey', { count: overflowCount }),
          }}
          onClickItem={onClickItem}
          onClickSecondaryLabel={onClickSecondaryLabel}
        />
      ) : null}
    </>
  )
}

export default CalendarGridDayChips
